module.exports = __webpack_public_path__ + "static/media/wallfinishes_allImpact_10y_n.946ae0c8.csv";